<template>
  <div style="width: 1278px; margin: 20px auto">
    <div class="flex">
      <div style="width: 257px; height: 634px; color: #fff; margin-right: 20px">
        <div
          class="flex align-center"
          style="height: 50px; background: #650004; padding-left: 24px"
        >
          <div class="mar-right-10 iconfont" :class="mySelectObj.icon"></div>
          <div>{{ mySelectObj.name }}</div>
        </div>
        <div
          style="
            wdith: 257px;
            background: #f8f8f8;
            height: 587px;
            color: #650004;
          "
        >
        <router-link
          v-for="(item, index) in navList"
          :key="index"
          class="news-link"
          :to="{
            name: 'noticeList',
            params: {
              id: mySelectObj.id
            },
          }"
          >
            <div
              :class="activeName === item.name ? 'active-class' : ''"
              class="flex align-center"
              @click="tabClick(item)"
              style="height: 50px; padding-left: 24px"
            >
              <div class="mar-right-10 iconfont" :class="item.icon"></div>
              <div>
                {{ item.name }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="flex-1">
        <div
          class="flex align-center"
          style="
            height: 50px;
            padding-left: 24px;
            border-bottom: 1px solid #c5c5c5;
          "
        >
          <div class="mar-right-10">
            <img class="w-h-100" src="../assets/image/sy.png" alt="" />
          </div>
          <div>
            当前位置：<span class="cursor-pointer" @click="gotoIndex">首页</span
            >/{{ mySelectObj.name
            }}<span v-if="activeName">/{{ activeName }}</span>
          </div>
        </div>
        <router-view :key="listId" :activeId="listId"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data() {
    return {
      showInfo: true,
      total: 0,
      pageData: {
        pageSize: 10,
        pageNumber: 1,
      },
      activeName: "",
      activeId: "",
      navList: [],
      messageList: [],
      itemInfo: {},
    };
  },
  inject: ["selectObj"],
  computed: {
    mySelectObj() {
      return this.selectObj?.() || {};
    },
    listId() {
      return this.activeId || this.$route.params.id;
    },
  },
  watch: {
    mySelectObj: {
      handler(newval, oldval) {
        this.activeId = "";
        this.activeName = "";
        this.pageData = {
          pageSize: 10,
          pageNumber: 1,
        };
        this.getNavList();
      },
      deep: true,
    },
  },
  methods: {
    gotoIndex() {
      localStorage.setItem('sort', 'sy')
      this.$router.push({
        path: '/index'
      })
    },
    tabClick(item) {
      this.pageData = {
        pageSize: 10,
        pageNumber: 1,
      };
      this.showInfo = true;
      this.activeName = item.name;
      this.activeId = item.id;
    },
    getNavList() {
      const param = {
        parentId: this.mySelectObj.id,
      };
      this.$api.index.getCatalog(param).then((res) => {
        if (res.code === 200) {
          this.navList = res.data;
        }
      });
    },
    getMsgInfo(item) {
      this.$router.push({
        name: "noticeDetaile",
        params: {
          noticeId: item.id,
        },
      });
      this.showInfo = false;
    },
  },
  created() {
    this.showInfo = this.$route.name !== "noticeDetaile";
  },
  mounted() {
    this.getNavList();
  },
};
</script>

<style scoped lang='less'>
a.news-link {
  color: #232324;
  margin-left: 3px;
}

a.news-link:hover, .active-class a.news-link {
  color: rgb(202, 28, 29);
}

.mar-right-10 {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}
.active-class {
  border-left: 2px solid #650004;
  background: #ffeff0;
}
.elipsis-class {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
ul li {
  list-style: initial;
  padding: 25px 0 0;
  cursor: pointer;
}
ul li::marker {
  color: red;
}
</style>
